import cx from "classnames";
import React, { ElementType, ReactNode } from "react";

import { Text } from "@/components/elements";
import CardUi from "@/components/elements/CardUI";

import styles from "./styles.module.css";
import { SubcategoriesLogos } from "./SubcategoriesLogos";

export type SubcategoriesGridProps = {
  className?: string;
  children: ReactNode;
};

type SubcategoryCardProps = {
  title?: string;
  imgSrc: string;
  imgHover?: string;
  slug: string;
  as?: ElementType;
  className?: string;
  text?: string;
  logos?: string[];
  subtitle?: string;
};

const SubcategoriesGrid = ({ className, children }: SubcategoriesGridProps) => {
  return (
    <ul className={cx(styles.subcategoriesGrid, className)}>{children}</ul>
  );
};

SubcategoriesGrid.Card = ({
  title,
  imgSrc,
  imgHover,
  slug,
  as = "div",
  className,
  text,
  logos,
  subtitle,
}: SubcategoryCardProps) => (
  <CardUi as={as} className={className}>
    <CardUi.BodyMedia
      href={slug}
      imgSrc={imgSrc}
      imgHover={imgHover}
      alt={title ?? text}
    />
    {Boolean(title) && <CardUi.Title href={slug}>{title}</CardUi.Title>}
    {Boolean(logos) && (
      <div className={styles.categoryInfoContainer}>
        <Text size="m" as={"h2"}>
          {text}
        </Text>
        <SubcategoriesLogos logos={logos} />
      </div>
    )}
    {Boolean(logos || text || subtitle) && (
      <CardUi.InfoBlock
        className={styles.brandsInfoContainer}
        topLeft={
          Boolean(text) &&
          Boolean(!logos) && <CardUi.Title href={slug}>{text}</CardUi.Title>
        }
        bottomLeft={
          Boolean(subtitle) && (
            <Text disableMarginBottom as={"h3"}>
              {subtitle}
            </Text>
          )
        }
      />
    )}
  </CardUi>
);

export default SubcategoriesGrid;
